var getBuiltIn = require('../internals/get-built-in');

module.exports = getBuiltIn('document', 'documentElement');



//////////////////
// WEBPACK FOOTER
// ./~/canvg/~/core-js/internals/html.js
// module id = 405
// module chunks = 0